import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/Navbar";
import { useNavigate } from "react-router-dom";

const Developers = () => {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate("/auth", { state: { preselectedType: "developer" } });
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6">
              Build Your Career with
              <span className="block text-secondary">Top Global Companies</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Join our network of elite developers and work with leading technology companies worldwide.
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={handleApplyClick}
            >
              Apply Now
            </Button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Why Join Our Platform?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4 text-primary">Competitive Compensation</h3>
              <p className="text-gray-600">Earn top-market rates working with established companies while enjoying the flexibility of remote work.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4 text-primary">Long-term Opportunities</h3>
              <p className="text-gray-600">Build lasting relationships with clients and secure stable, long-term remote positions with growth potential.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4 text-primary">Global Network</h3>
              <p className="text-gray-600">Connect with developers worldwide and work on challenging projects for industry-leading companies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">1</div>
              <h3 className="text-lg font-semibold mb-2">Apply</h3>
              <p className="text-gray-600">Submit your application and showcase your skills</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">2</div>
              <h3 className="text-lg font-semibold mb-2">Technical Assessment</h3>
              <p className="text-gray-600">Complete our vetting process to verify your expertise</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">3</div>
              <h3 className="text-lg font-semibold mb-2">Match</h3>
              <p className="text-gray-600">Get matched with companies that fit your skills and preferences</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">4</div>
              <h3 className="text-lg font-semibold mb-2">Start Working</h3>
              <p className="text-gray-600">Begin your remote work journey with top companies</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Developers;